const UNKNOWN = "- -";
export const getRiskProfileFromFinScore = (finScore) => {
    if (finScore === undefined) {
        return UNKNOWN;
    }
    const parsedFinScore = parseFloat(finScore);
    if (parsedFinScore >= 90) {
        return "Aggressive";
    }
    else if (parsedFinScore >= 70) {
        return "Mod. Aggressive";
    }
    else if (parsedFinScore >= 50) {
        return "Moderate";
    }
    else if (parsedFinScore >= 30) {
        return "Mod. Conservative";
    }
    else {
        return "Conservative";
    }
};
//# sourceMappingURL=getRiskProfileFromFinScore.js.map